<template>
  <Modal v-model="showSessionPopup" @input="onModalInput">
    <p class="text-xl font-medium leading-tight pb-2">
      {{ $t('popups.session.title') }}
    </p>
    <p class="text-sm leading-tight pb-5 xl:pb-8">
      {{ $t('popups.session.description') }}
    </p>
    <div class="flex">
      <Button
        @click.prevent="keepSessionAlive"
      >
        {{ $t('popups.session.keepAliveButton') }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import SessionPopup from '~app/psp/base/session-popup.ts'
import Button from '~brand-components/austrian/button/button.vue'
import Modal from '~brand-components/austrian/modal/modal.vue'

export default SessionPopup.extend({
  components: {
    Button,
    Modal,
  },
})
</script>
